import { ReactElement, useEffect, useState } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { GATEWAY_PAYMENT_TOKEN, SALE_ID } from '../../../config/cacheKey';
import LayoutWithoutDrawer from '../../../layouts/LayoutWithoutDrawer';
import { IGetWaitForCustomerApproveSalesResponse } from '../../../models/sale.model';
import { RootState } from '../../../redux/store';
import { GetWaitForCustomerApproveSales } from '../../../services/sale.service';
import { GetTotalBalance } from '../../../services/wallet.service';
import Notifications from '../../notification/notifications';
import OngoingDetailPurchase from '../../purchase/ongoingDetailPurchase';
import OngoingPurchases from '../../purchase/ongoingPurchases';
import Payment from '../../requestSteps/inquiryFee/resultPayment/payment';
import GuarantorFile from './guarantor/detail/guarantorFile';
import GurantorDetail from './guarantor/detail/gurantorDetail';
import Guarantor from './guarantor/guarantor';
import HomeMenu from './homeMenu';
import { IComponentKey } from './IHomeMenu';
import NewPayment from './newPayment/newPayment';
import PurchaseRecordDetail from './purchaseRecords/purchaseRecordDetial';
import PurchaseRecords from './purchaseRecords/purchaseRecords';
import TradeContainer from './trade/tradeContainer';


const HomeMenuContainer = ({ setTabChild }: { setTabChild: (id: number) => void }) => {
    const [state, setState] = useState<IComponentKey>('home');
    const [updateOngoingPurchasesState, setUpdateOngoingPurchasesState] = useState<boolean>(false);
    const [totalBalance, setTotalBalance] = useState<number>();
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as IComponentKey;
    const stateReduxBottomNav = useSelector((state: RootState) => state.loansTabComponents.prevState);


    const queryClient = useQueryClient();

    const [waitingSales, setWaitingSales] = useState<IGetWaitForCustomerApproveSalesResponse[]>();

    const { mutateAsync: GetTotalBalanceMutate } = useMutation(GetTotalBalance, {
        onSuccess: (data) => {
            setTotalBalance(data)
        }
    })
    const dispatch = useDispatch();
    useEffect(() => {
        const path = window.location.hash;
        const newPath = window.location.href;
        const newCleanUrl = `${window.location.origin}/#/`;
        const urlParams = new URLSearchParams(window.location.search);
        const saleKey = path.split('/')[2];

        if (newPath.includes("receiptPayment")) {
            const token = urlParams.get('t');

            localStorage.setItem(GATEWAY_PAYMENT_TOKEN, token!)
            setState('receiptPayment');

            window.history.replaceState(null, '', newCleanUrl);
        }

        //trade

        // const target = urlParams.get('target');
        // if (target && target?.includes("trade")) {

        //     setState('trade');
        //     window.history.replaceState(null, '', newCleanUrl);
        // }
        //trade

        if (path.toLowerCase().includes("/ongoingdetailpurchase/") && saleKey != null && saleKey != "") {
            setState('ongoingDetailPurchase');
            const newPath = `${window.location.protocol}//${window.location.host}`;

            queryClient.setQueryData(SALE_ID, saleKey);

            window.history.replaceState(null, '', newPath);
        }

        GetTotalBalanceMutate();
        GetWaitForCustomerApproveSalesMutate();

    }, []);
    useEffect(() => {

        if (updateOngoingPurchasesState) {
            GetWaitForCustomerApproveSalesMutate();
            setUpdateOngoingPurchasesState(false)
        }

        if (stateFromRedux.includes('home')) {
            setState('home');
        }
        else if (stateFromRedux.includes('guarantors')) {
            setState('garantour');
        }

        else if (stateFromRedux.includes('DetailAttachedFile')) {
            setState('guarantorDetail');
        }

        else if (stateFromRedux.includes('loanDetailFullScreenMultiImage')) {
            setState('guarantorFile');

        }
        else if (stateFromRedux.includes('purchaseRecords')) {
            setState('purchaseRecords');

        }
        else if (stateFromRedux.includes('purchaseRecordDetail')) {
            setState('purchaseRecordDetail');

        }
        else if (stateFromRedux.includes('ongoingPurchases')) {
            setState('ongoingPurchases');

        } else if (stateFromRedux.includes('ongoingDetailPurchase')) {
            setState('ongoingDetailPurchase');

        }
        else if (stateFromRedux.includes('trade')) {
            setState('trade')
        }

    }, [stateFromRedux]);
    useEffect(() => {
        if (stateReduxBottomNav.includes('home')) {

            setState('home');
        }
    }, [stateReduxBottomNav])


    const { mutate: GetWaitForCustomerApproveSalesMutate } = useMutation(GetWaitForCustomerApproveSales, {
        onSuccess: (data: IGetWaitForCustomerApproveSalesResponse[]) => {

            if (data != null && data.length > 0) {
                setWaitingSales(data)
            }
        }
    });


    const menuStatus: Record<IComponentKey, ReactElement> = {
        home: <HomeMenu setState={setState} setTabChild={setTabChild} totalBalance={totalBalance} waitingPurchases={waitingSales} />,
        garantour: <Guarantor setState={setState} />,
        guarantorDetail: <GurantorDetail setState={setState} />,
        guarantorFile: <GuarantorFile setState={setState} />,
        purchaseRecords: <PurchaseRecords setState={setState} setTabChild={setTabChild} />,
        purchaseRecordDetail: <PurchaseRecordDetail />,
        notifications: <Notifications />,
        ongoingPurchases: <OngoingPurchases waitingPurchases={waitingSales!} setState={setState} setTabChild={setTabChild} />,
        ongoingDetailPurchase: <OngoingDetailPurchase ongoingPurchases={waitingSales! ? waitingSales.length : 0} setWaitingSales={setWaitingSales} setState={setState} />,
        newPayment: <NewPayment setState={setState} />,
        receiptPayment: <LayoutWithoutDrawer ><Payment parentRoute='home' /> </LayoutWithoutDrawer>,
        trade: <TradeContainer setTabChild={setTabChild} />

    }
    return (
        <div >
            {menuStatus[state]}
        </div>
    )
}

export default HomeMenuContainer